import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ExpandableSection } from '../ExpandableSection';
import { OperadorDetails } from './OperadorDetails';
export var ExpandableSectionOperadores = function (_a) {
    var operadores = _a.operadores;
    return (_jsx(ExpandableSection, { title: "Dados dos Operadores", children: operadores === null || operadores === void 0 ? void 0 : operadores.map(function (operador, index) { return (_jsx(OperadorDetails, { operador: operador, index: index + 1 }, operador.id)); }) }));
};
